import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-233" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-6xl" data-id="element-234" data-mp="3fz5mzurn5ef7">
        <h2 className="text-center font-display text-[1.9rem] font-extrabold leading-tight tracking-tight text-navy sm:text-[2.8rem]" data-id="element-235" data-mp="3fxuly2pkykrs">
          Was Lehrkräfte sagen
        </h2>
        <p className="mt-4 flex items-center justify-center gap-2 text-sm font-semibold text-navy/75" data-id="element-236" data-mp="36zr015aonlzg">
          <Stars data-id="element-237" data-mp="31z3c4shr3l9g" />
          4,9/5 · 1.500+ Lehrkräfte
        </p>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-238" data-mp="2x09uqozcfa40">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-ice p-7" data-id="element-239" data-mp="2s28cg69qretl">
              <Stars data-id="element-240" data-mp="v9ygvdusdzbb" />
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-navy" data-id="element-241" data-mp="v8dnhrk7kmf1">
                „{item.quote}“
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3" data-id="element-242" data-mp="q8ivtlslzssx">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand font-display text-sm font-extrabold text-white" aria-hidden="true" data-id="element-243" data-mp="h4dcylqnjo46">
                  {item.name.charAt(0)}
                </span>
                <span data-id="element-244" data-mp="7a4xaympzpnf">
                  <span className="block text-sm font-bold text-navy" data-id="element-245" data-mp="c6ljhnacztxv">{item.name}</span>
                  <span className="block text-xs text-navy/60" data-id="element-246" data-mp="zwfus0f15ag0">{item.location}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-xs text-navy/50" data-id="element-247" data-mp="14xlp22oc95rn">
          Beispielhafte Testimonials zu Demonstrationszwecken.
        </p>
      </div>
    </section>;
}
function Stars() {
  return <span className="flex gap-0.5" role="img" aria-label="5 von 5 Sternen" data-id="element-248" data-mp="v3mqfdnh444g">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-sun text-sun" aria-hidden="true" data-id="element-249" data-mp="1nlqr95pckioc" data-mpi={i} />)}
    </span>;
}